export const aceDaBrainCatalog = {
  name: 'Ace Da Brain',
  realName: 'Andreas Schmidt',
  aliases: [
    'ACE DA BRAIN',
    "ACE'S DELIGHT",
    'SONIC INC.',
    'PERVADING CALL',
    'AIRFIRE',
    'BACED!',
    'PERVADING CALL 2',
    'BRAIN CRUZ BROTHERS',
    'A2C',
    'CRASH DUDEZ',
    'ONYX CORE',
    'DAREDEVIL',
    'GOTHIC VISION',
    'LIQUID BASE',
    'MAG',
    'MYSTERIA',
    'NAUTILUS',
    'OS PROJECT',
    'OUTCAST',
    'SHADOW WARRIORS',
    'TRAVELLER',
    'WALDMEISTER',
  ],
  producedFor: [
    'ZATOX',
    'LE SHUUK',
    'CAPTAIN JACK',
    'KASPAR',
    'LYAH NOIR',
    'NULLHERTZ',
    'MOREES',
    'TOM FRANKE',
    'CHRIS WACUP',
    'TALLA 2XLC',
    'MERZO',
    'TAI',
    'AZZIDO DA BASS',
    'PHILIPPE LEMOT',
    'TRYST',
    'MYNOOREY',
    'MARK BALE',
    'FRANKA MORGANO (MAGIC AFFAIR)',
    'ROBKAY',
    'KAMBUTCHA',
    'SET4LIFE',
    'MARC LA CRUZ',
    'JAY FROG',
    'MARC TYPE',
    'DANIEL GEHRING',
    'GEORGE ACOSTA',
    'MARK L2K',
    'GRIM REAPER',
    'TILLMANN UHRMACHER',
    'WOLFRAM DE MARCO',
  ],
  remixesFor: [
    'ALPHAVILLE',
    'CAPELLA',
    'GURU JOSH',
    'SUPERFREAKZ',
    'TIESTO',
    'SEAN FINN',
    'NOIZE GENERATION',
    'TIMBO',
    'MEGAMIND',
    'KARLA BLUM',
    'CHICO CHIQUITA',
    'MYNOOREY',
    'BROOKLYN BOUNCE',
    'POINT BLANK',
    'MASSIVE DITTO',
    'JAY FROG',
    'NIELS VAN GOGH',
    'DARIO RODRIGUEZ',
    'TALLA 2XLC',
    'DJ TAUCHER',
    'DUMONDE',
    'DEADMOU5',
    'STEVE CYPRESS',
    'PETER RIES',
    'FILO & PERI',
    'KYAU & ALBERT',
    'PETER LUTZ',
    'JOHN MICHAEL TSIROS',
    'CAPTAIN JACK',
    'LEGEND B',
    'TUBE TECH',
    'ONE MORE ANGEL',
    'ALEX BARTLETT',
    'LISAYA VS. THOMAS PETTERSON',
    'JAMMASTER A',
    'CARL B feat. KATIE MARNE',
    'FRED BAKER',
    'NURSE & PATIENT',
    'SO PROJECT',
    'CYCLIX',
    'DJ JO',
    'ANDY LING',
    'DJ CYGLASS',
    'XALLUX',
    'RENATO TANKIS & DJ SAVIETTO',
  ],
};

export const catalogArtists = [
  {
    id: 'kaspar',
    name: 'Kaspar',
    label: 'Fe Chrome Records',
    genre: 'Techno / Dark Techno',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/c2d15c9d-fd4c-48dc-b884-daf68069091b_Kaspar.jpg?v=ae681d534a82fcab2131843f9ec7ab47',
  },
  {
    id: 'le-shuuk',
    name: 'Le Shuuk',
    label: 'AceAge Records',
    genre: 'Big Room / Dance',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/27ca7182-572f-49e2-ae6f-fb520e5f0e49_Le-Shuuk.jpg?v=8b16b3a6cf7afe40ba47d1f36d5ab535',
  },
  {
    id: 'captain-jack',
    name: 'Captain Jack',
    label: 'AceAge Records',
    genre: 'Eurodance / Pop',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/53e2a153-3ed8-4eb1-bc33-987b5e24c41a_cAPTAIN-jaCK.png?v=8f0ead2315e33d9b1f5191f2f2b373a0',
  },
  {
    id: 'talla-2xlc',
    name: 'Talla 2XLC',
    label: 'AceAge Records',
    genre: 'Trance / Electronic',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/ea6fb336-104d-41d0-82e6-649148be6398_Talla-2xlc.jpg?v=c20b1ad0f45e3d7938c36639541ac713',
  },
  {
    id: 'marco-petralia',
    name: 'Marco Petralia',
    label: 'Fe Chrome Records',
    genre: 'Techno / Electronic',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/2a9a77e9-58bd-4226-a988-131fbf752d95_Marco-Petralia.jpg?v=541d6c188275035c11d76ae1477d1e30',
  },
  {
    id: 'nullhertz',
    name: 'NULLHERTZ',
    label: 'Fe Chrome Records',
    genre: 'Peaktime Techno',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/1cefd418-e41d-428d-a13f-13ebd19dc169_WhatsApp-Image-2025-10-24-at-22.52.51.jpeg?v=99ef7d75271e910f4499588f797efbf9',
  },
  {
    id: 'tom-franke',
    name: 'Tom Franke',
    label: 'AceAge Records',
    genre: 'Electronic / Dance',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/57de260f-c615-4349-a180-d910d5c0def9_Tom-Franke.jpg?v=3b8be3c4701f9b9b7a58f153c4592c99',
  },
  {
    id: 'morees',
    name: 'MOREES',
    label: 'AceAge Records',
    genre: 'Melodic Techno',
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/46240058-3747-4287-bb31-c8560ad8c4c5_WhatsApp-Image-2026-04-22-at-14.49.28.jpeg?v=1bc80f96a79c6020414720ea44b643f7',
  },
];
